"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROGRESS_BAR_TYPES = exports.PROGRESS_BAR_TYPE_BARS = exports.PROGRESS_BAR_TYPE_DOTS = exports.PROGRESS_BAR_SIZES = exports.PROGRESS_BAR_SIZE_DEFAULT = exports.PROGRESS_BAR_SIZE_SMALL = exports.STEP_STATUS_TYPES = exports.STEP_STATUS_WAITING = exports.STEP_STATUS_PROCESS = exports.STEP_STATUS_FINISH = void 0;
var STEP_STATUS_FINISH = 'finish';
exports.STEP_STATUS_FINISH = STEP_STATUS_FINISH;
var STEP_STATUS_PROCESS = 'process';
exports.STEP_STATUS_PROCESS = STEP_STATUS_PROCESS;
var STEP_STATUS_WAITING = 'wait';
exports.STEP_STATUS_WAITING = STEP_STATUS_WAITING;
var STEP_STATUS_TYPES = [STEP_STATUS_FINISH, STEP_STATUS_PROCESS, STEP_STATUS_WAITING];
exports.STEP_STATUS_TYPES = STEP_STATUS_TYPES;
var PROGRESS_BAR_SIZE_SMALL = 'small';
exports.PROGRESS_BAR_SIZE_SMALL = PROGRESS_BAR_SIZE_SMALL;
var PROGRESS_BAR_SIZE_DEFAULT = 'default';
exports.PROGRESS_BAR_SIZE_DEFAULT = PROGRESS_BAR_SIZE_DEFAULT;
var PROGRESS_BAR_SIZES = [PROGRESS_BAR_SIZE_SMALL, PROGRESS_BAR_SIZE_DEFAULT];
exports.PROGRESS_BAR_SIZES = PROGRESS_BAR_SIZES;
var PROGRESS_BAR_TYPE_DOTS = 'dots';
exports.PROGRESS_BAR_TYPE_DOTS = PROGRESS_BAR_TYPE_DOTS;
var PROGRESS_BAR_TYPE_BARS = 'bars';
exports.PROGRESS_BAR_TYPE_BARS = PROGRESS_BAR_TYPE_BARS;
var PROGRESS_BAR_TYPES = [PROGRESS_BAR_TYPE_DOTS, PROGRESS_BAR_TYPE_BARS];
exports.PROGRESS_BAR_TYPES = PROGRESS_BAR_TYPES;